<div fxFlex='100' class='mvr-side-nav-content'>
  <div fxLayout='column' fxFill>
    <div fxFlex='42' class='mvr-top-section-container'>
      <div class='mvr-side-nav-title'>{{ 'GENERIC.driver' | translate | uppercase }}</div>
      <span class='mvr-side-nav-driver'>
				{{ rptService.selectedRows[0]['fullName'] | truncateString: 30 }} -
        {{ rptService.selectedRows[0]['pin'] }}
			</span>

      <div class='mvr-side-nav-md-license' *ngIf="rptService.selectedRows[0]['alertCreated']">
        <div class='mvr-side-nav-title'>
          {{ 'GENERIC.created' | translate | uppercase }}
        </div>
        <span class='mvr-side-nav-license-info'>
					{{ rptService.selectedRows[0]['alertCreated'] }}
				</span>
      </div>

      <div class='mvr-side-nav-md-license' *ngIf="rptService.selectedRows[0]['alertDetail']">
        <div class='mvr-side-nav-title'>
          {{ 'ALERTS.alertDetail' | translate | uppercase }}
        </div>
        <span class='mvr-side-nav-license-info'>
					{{ rptService.selectedRows[0]['alertDetail'] }}
				</span>
      </div>

      <mat-divider></mat-divider>

      <form
        [formGroup]='alertResolveForm'
        (submit)='submitAlertResolve()'
        *ngIf='!rptService.resolveAlertShowActionTaken'
      >
        <div
          *ngIf="rptService.resolveAlertAdditionalContent"
          [innerHTML]="rptService.resolveAlertAdditionalContent"
          class="alertAdditionalContent"
        ></div>

        <div>
          <div class='mvr-order-hint' *ngIf='!rptService.resolveAlertShowActionTaken'>
            <div class='mvr-side-nav-title'>
              {{ cService.readyTranslations.generic.acknowledgement | uppercase }}
            </div>
            {{ cService.readyTranslations.alerts.acknowledgement }}
          </div>

          <div *ngIf="rptService.resolveAlertDisplayAuthorisation" class='alert-action'>
            <mat-checkbox appearance='fill' class='' formControlName='alertResolveAck' #resolve>
              {{ 'ALERTS.alertResolved' | translate }}
            </mat-checkbox>

            <div class='alert-text'>
              {{ 'ALERTS.leaveAsUnresolved' | translate }}
            </div>

            <div>
              <mat-radio-group
                formControlName='alertActionsTaken'
                [disabled]='!resolve.checked'
                fxLayout='column'
                class='margin-t-15'
              >
                <mat-radio-button value='AUTHORISED' class='radio-button'>
                  {{ cService.readyTranslations.generic.authorised }}
                </mat-radio-button>
                <mat-radio-button value='NOT AUTHORISED' class='radio-button'>
                  {{ cService.readyTranslations.generic.notAuthorised }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <div class="alert-action" *ngIf="!rptService.resolveAlertDisplayAuthorisation">
            <mat-checkbox appearance='fill' class='' formControlName='alertResolveAck'>
              {{ cService.readyTranslations.alerts.alertResolved }}
            </mat-checkbox>
            <div class='mvr-order-hint'>
              {{ cService.readyTranslations.alerts.leaveAsUnresolved }}
            </div>
            <mat-form-field appearance='fill' class='mvr-side-nav-driver margin-t-10'>
              <mat-label>{{ cService.readyTranslations.alerts.actionsTaken }}</mat-label>
              <textarea
                matInput
                formControlName='alertActionsTaken'
                #input
                maxlength='250'
                rows='10'
              ></textarea>
              <mat-hint align='end'>{{ input.value?.length || 0 }}/250</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div>
          <button
            mat-flat-button
            [disabled]='!alertResolveForm.valid || !isUpdateButtonActive'
            [class.mvr-order-btn-retry]='rptService.resolveAlertFailedSuggestions?.length'
            class='mvr-order-btn'
          >
            {{ rptService.resolveAlertButtonText | uppercase }}
          </button>
        </div>
      </form>

      <!-- No form required just show the alert resolution comments -->
      <div class='mvr-side-nav-md-license' *ngIf='rptService.resolveAlertShowActionTaken'>
        <div class='mvr-side-nav-title'>
          {{ cService.readyTranslations.alerts.resolveBy | uppercase }}
        </div>
        <div class='mvr-side-nav-license-info'>
          {{ rptService.selectedRows[0]['alertResolvedBy'] }}
        </div>
        <br />
        <br />
        <div class='mvr-side-nav-title'>
          {{ cService.readyTranslations.alerts.resolveDate | uppercase }}
        </div>
        <div class='mvr-side-nav-license-info'>
          {{ rptService.selectedRows[0]['alertResolvedDate'] }}
        </div>
        <br />
        <br />
        <div class='mvr-side-nav-title'>
          {{ cService.readyTranslations.alerts.actionsTaken | uppercase }}
        </div>
        <div class='mvr-side-nav-license-info'>
          {{ rptService.selectedRows[0]['actionTaken'] }}
        </div>
      </div>

      <div
        *ngIf='!rptService.resolveAlertShowActionTaken && rptService.resolveAlertFailedSuggestions?.length'
        class='mvr-fail-suggestion order-mvr-error'
      >
        <ul class='mvr-failed-suggestion-list padding-left-zero'>
          <li *ngFor='let FailedMvrSuggestion of rptService.resolveAlertFailedSuggestions'>
            {{ FailedMvrSuggestion }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
